module.exports = __webpack_public_path__ + "img/6982fc7.svg";